/* tslint:disable */

declare var Object: any;
export interface AnswersInterface {
  "sfdcId"?: string;
  "ts2__Answer__c"?: string;
  "ts2__Legacy_AnswerID__c"?: string;
  "ts2__Order__c"?: number;
  "ts2__Question__c"?: string;
  "ts2__Score__c"?: number;
  "ts2__ts2IsTxt__c"?: boolean;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class Answers implements AnswersInterface {
  "sfdcId": string;
  "ts2__Answer__c": string;
  "ts2__Legacy_AnswerID__c": string;
  "ts2__Order__c": number;
  "ts2__Question__c": string;
  "ts2__Score__c": number;
  "ts2__ts2IsTxt__c": boolean;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: AnswersInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Answers`.
   */
  public static getModelName() {
    return "Answers";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Answers for dynamic purposes.
  **/
  public static factory(data: AnswersInterface): Answers{
    return new Answers(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Answers',
      plural: 'Answers',
      path: 'Answers',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "ts2__Answer__c": {
          name: 'ts2__Answer__c',
          type: 'string'
        },
        "ts2__Legacy_AnswerID__c": {
          name: 'ts2__Legacy_AnswerID__c',
          type: 'string'
        },
        "ts2__Order__c": {
          name: 'ts2__Order__c',
          type: 'number'
        },
        "ts2__Question__c": {
          name: 'ts2__Question__c',
          type: 'string'
        },
        "ts2__Score__c": {
          name: 'ts2__Score__c',
          type: 'number'
        },
        "ts2__ts2IsTxt__c": {
          name: 'ts2__ts2IsTxt__c',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
